export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { id: 'hot-blood', name: '热血', slug: 'hot-blood', icon: 'ri-fire-line' },
  { id: 'romance', name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { id: 'suspense', name: '悬疑', slug: 'suspense', icon: 'ri-search-eye-line' },
  { id: 'sci-fi', name: '科幻', slug: 'sci-fi', icon: 'ri-rocket-line' },
  { id: 'horror', name: '恐怖', slug: 'horror', icon: 'ri-ghost-line' },
  { id: 'slice-of-life', name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line' },
];

export const comics = [
  {
    id: 1,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'hot-blood',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manga%20cover%2C%20young%20warrior%20with%20flame%20aura%2C%20epic%20fantasy%20battle%20scene%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20anime%20style%20illustration%20with%20detailed%20character%20design%2C%20clean%20simple%20background&width=400&height=560&seq=manga-doupo&orientation=portrait',
    rating: 9.5,
    status: '连载中',
    updatedAt: '2026-08-04',
    latestChapter: '第1258话',
    description: '这是一个斗气的世界，斗之气，分九段，从高到低分别为：斗皇，斗宗，斗尊，斗圣，斗帝。少年萧炎，在创造了家族空前的修炼纪录后突然成为了废人...',
    chapters: [
      { num: 1258, title: '最后的决战', date: '2026-08-04' },
      { num: 1257, title: '魂天帝现身', date: '2026-08-03' },
      { num: 1256, title: '古帝洞府', date: '2026-08-02' },
      { num: 1255, title: '九星斗圣', date: '2026-08-01' },
      { num: 1254, title: '突破境界', date: '2026-07-31' },
      { num: 1253, title: '净莲妖火', date: '2026-07-30' },
      { num: 1252, title: '天府联盟', date: '2026-07-29' },
      { num: 1251, title: '魂殿的秘密', date: '2026-07-28' },
      { num: 1250, title: '药老归来', date: '2026-07-27' },
      { num: 1249, title: '丹塔大会', date: '2026-07-26' },
    ],
    views: 12800000,
  },
  {
    id: 2,
    title: '完美世界',
    author: '辰东',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manga%20cover%2C%20young%20boy%20with%20divine%20powers%20in%20ancient%20mythological%20world%2C%20celestial%20beings%20and%20magical%20creatures%2C%20golden%20and%20white%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-wanmei&orientation=portrait',
    rating: 9.3,
    status: '连载中',
    updatedAt: '2026-08-04',
    latestChapter: '第2015话',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。问苍茫大地，谁主沉浮？！',
    chapters: [
      { num: 2015, title: '最终之地', date: '2026-08-04' },
      { num: 2014, title: '帝落时代', date: '2026-08-03' },
      { num: 2013, title: '仙王对决', date: '2026-08-02' },
      { num: 2012, title: '界海之秘', date: '2026-08-01' },
      { num: 2011, title: '不朽之王', date: '2026-07-31' },
    ],
    views: 11500000,
  },
  {
    id: 3,
    title: '大王饶命',
    author: '会说话的肘子',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manga%20cover%2C%20funny%20high%20school%20student%20with%20supernatural%20powers%2C%20humorous%20facial%20expression%2C%20bright%20vibrant%20colors%2C%20modern%20urban%20setting%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-dawang&orientation=portrait',
    rating: 9.1,
    status: '已完结',
    updatedAt: '2026-07-20',
    latestChapter: '第1380话（完结）',
    description: '灵气复苏的时代，世界充满了机遇和挑战。吕树靠着毒鸡汤成为了大佬，然而他最大的秘密却是...靠怼人来获取负面情绪值进行升级。',
    chapters: [
      { num: 1380, title: '新的开始（完结）', date: '2026-07-20' },
      { num: 1379, title: '最终对决', date: '2026-07-19' },
      { num: 1378, title: '真相大白', date: '2026-07-18' },
    ],
    views: 10200000,
  },
  {
    id: 4,
    title: '全职高手',
    author: '蝴蝶蓝',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20manga%20cover%2C%20professional%20gamer%20holding%20mouse%20and%20keyboard%2C%20competitive%20gaming%20atmosphere%2C%20cool%20urban%20style%2C%20blue%20and%20silver%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-quanzhi&orientation=portrait',
    rating: 9.4,
    status: '已完结',
    updatedAt: '2026-06-15',
    latestChapter: '第1736话（完结）',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他栖身于一家网吧成了一个小小的网管...',
    chapters: [
      { num: 1736, title: '巅峰之战（完结）', date: '2026-06-15' },
      { num: 1735, title: '最后的舞台', date: '2026-06-14' },
    ],
    views: 9800000,
  },
  {
    id: 5,
    title: '仙王的日常生活',
    author: '枯玄',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20school%20life%20manga%20cover%2C%20powerful%20immortal%20student%20hiding%20his%20true%20identity%2C%20modern%20school%20uniform%2C%20funny%20slice%20of%20life%20scene%2C%20bright%20pastel%20colors%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-xianwang&orientation=portrait',
    rating: 8.9,
    status: '连载中',
    updatedAt: '2026-08-03',
    latestChapter: '第892话',
    description: '王令，六岁随手干掉了妖界妖王，年仅十六岁就已经是世界最强。然而这样的一个人，却只想安安静静地上学，过一个普通高中生的生活。',
    chapters: [
      { num: 892, title: '校园祭', date: '2026-08-03' },
      { num: 891, title: '新来的转校生', date: '2026-08-02' },
    ],
    views: 7600000,
  },
  {
    id: 6,
    title: '一念永恒',
    author: '耳根',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manga%20cover%2C%20young%20disciple%20seeking%20immortality%20in%20ancient%20Chinese%20setting%2C%20mystical%20mountains%20and%20clouds%2C%20soft%20green%20and%20gold%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-yinian&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    updatedAt: '2026-08-04',
    latestChapter: '第1076话',
    description: '白小纯，一个追求长生不老的少年。他怕死到了令人发指的程度，为了能活下去，他可以不要脸面，可以放弃一切...',
    chapters: [
      { num: 1076, title: '长生之谜', date: '2026-08-04' },
      { num: 1075, title: '通天世界', date: '2026-08-03' },
    ],
    views: 8900000,
  },
  {
    id: 7,
    title: '元尊',
    author: '天蚕土豆',
    category: 'hot-blood',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manga%20cover%2C%20prince%20with%20divine%20dragon%20spirit%2C%20ancient%20Chinese%20palace%20background%2C%20epic%20atmosphere%2C%20golden%20and%20crimson%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-yuanzun&orientation=portrait',
    rating: 9.0,
    status: '已完结',
    updatedAt: '2026-05-10',
    latestChapter: '第1502话（完结）',
    description: '周元，大周王朝的太子，身负圣龙气运，本该是天之骄子。然而命运多舛，他在出生之日，被敌国大武以怨龙毒吞噬了气运...',
    chapters: [
      { num: 1502, title: '天地大同（完结）', date: '2026-05-10' },
      { num: 1501, title: '圣龙之怒', date: '2026-05-09' },
    ],
    views: 8100000,
  },
  {
    id: 8,
    title: '诡秘之主',
    author: '爱潜水的乌贼',
    category: 'suspense',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20manga%20cover%2C%20detective%20in%20steampunk%20Victorian%20era%2C%20dark%20atmospheric%20street%20scene%2C%20mysterious%20occult%20symbols%2C%20foggy%20lamplight%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-guimi&orientation=portrait',
    rating: 9.6,
    status: '连载中',
    updatedAt: '2026-08-04',
    latestChapter: '第1430话',
    description: '蒸汽与机械的浪潮中，谁能触及非凡？历史和黑暗的迷雾里，又是谁在耳语？我从诡秘中醒来，睁眼看见这个世界：枪械、大炮、巨舰、飞空艇...',
    chapters: [
      { num: 1430, title: '愚者的盛宴', date: '2026-08-04' },
      { num: 1429, title: '序列之上', date: '2026-08-03' },
    ],
    views: 13500000,
  },
  {
    id: 9,
    title: '牧神记',
    author: '宅猪',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20manga%20cover%2C%20young%20shepherd%20boy%20with%20ancient%20artifacts%2C%20vast%20grasslands%20and%20divine%20beasts%2C%20epic%20journey%2C%20warm%20earth%20and%20sky%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-mushen&orientation=portrait',
    rating: 9.3,
    status: '连载中',
    updatedAt: '2026-08-03',
    latestChapter: '第1890话',
    description: '大墟的祖训说，天黑，别出门。大墟残老村的老弱病残们，捡到了一个婴儿，起名秦牧，含辛茹苦将他养大...',
    chapters: [
      { num: 1890, title: '古神觉醒', date: '2026-08-03' },
      { num: 1889, title: '天道之谜', date: '2026-08-02' },
    ],
    views: 9400000,
  },
  {
    id: 10,
    title: '星域战神',
    author: '逆苍天',
    category: 'sci-fi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20mecha%20manga%20cover%2C%20pilot%20in%20futuristic%20spacesuit%2C%20giant%20robot%20battle%20in%20space%2C%20neon%20lights%20and%20stars%2C%20cool%20silver%20and%20cyan%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-xingyu&orientation=portrait',
    rating: 8.7,
    status: '连载中',
    updatedAt: '2026-08-04',
    latestChapter: '第658话',
    description: '在遥远的未来，人类已经遍布星河。少年林昊天生拥有强大的精神力量，驾驶着古老的机甲，踏上成为星域最强者的征途...',
    chapters: [
      { num: 658, title: '星际战场', date: '2026-08-04' },
      { num: 657, title: '机甲觉醒', date: '2026-08-03' },
    ],
    views: 5200000,
  },
  {
    id: 11,
    title: '天官赐福',
    author: '墨香铜臭',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20fantasy%20manga%20cover%2C%20heavenly%20official%20in%20flowing%20robes%2C%20beautiful%20ancient%20Chinese%20aesthetic%2C%20cherry%20blossoms%20and%20divine%20palace%2C%20soft%20pink%20and%20gold%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-tianguan&orientation=portrait',
    rating: 9.4,
    status: '已完结',
    updatedAt: '2026-04-20',
    latestChapter: '第244话（完结）',
    description: '八百年前，谢怜曾是风光无限的太子殿下，一朝得道飞升，成为武神。可谁能想到，这位金枝玉叶的贵人，竟三次飞升三次被贬...',
    chapters: [
      { num: 244, title: '花好月圆（完结）', date: '2026-04-20' },
      { num: 243, title: '终成眷属', date: '2026-04-19' },
    ],
    views: 11000000,
  },
  {
    id: 12,
    title: '深夜书屋',
    author: '纯洁滴小龙',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20manga%20cover%2C%20mysterious%20bookstore%20at%20midnight%2C%20ghostly%20figures%20in%20shadows%2C%20eerie%20atmosphere%2C%20dark%20blue%20and%20purple%20tones%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=400&height=560&seq=manga-shenye&orientation=portrait',
    rating: 8.8,
    status: '连载中',
    updatedAt: '2026-08-02',
    latestChapter: '第742话',
    description: '一家只在深夜营业的书店，一个被诅咒的书店老板，以及那些不该存在于这个世界的客人们...当夜幕降临，故事才刚刚开始。',
    chapters: [
      { num: 742, title: '午夜来客', date: '2026-08-02' },
      { num: 741, title: '亡者的委托', date: '2026-08-01' },
    ],
    views: 4800000,
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得期待的十大国产漫画',
    category: 'hot-blood',
    author: '漫画编辑小陈',
    date: '2026-08-01',
    summary: '国产漫画市场蓬勃发展，各大平台佳作频出。本文为大家盘点2026年最值得期待的十部国产漫画，每一部都是精品中的精品。',
    content: `<p>2026年，国产漫画市场迎来了前所未有的繁荣期。随着越来越多的优秀创作者加入这个行业，国产漫画的质量和数量都在飞速提升。今天，我们就来盘点一下2026年最值得期待的十大国产漫画。</p>

<h3>1. 《斗破苍穹》续篇</h3>
<p>作为国产漫画的经典之作，《斗破苍穹》在完结后依然保持着极高的人气。据悉，作者天蚕土豆正在筹备续篇，将会讲述萧炎在更高位面的冒险故事。</p>

<h3>2. 《完美世界》最终章</h3>
<p>辰东的《完美世界》已经连载多年，据传即将进入最终篇章。荒天帝的传奇即将迎来终章，这无疑是所有漫迷最期待的时刻。</p>

<h3>3. 《诡秘之主》第二部</h3>
<p>乌贼的《诡秘之主》以其独特的世界观和精妙的情节设计，赢得了无数读者的喜爱。第二部的消息一出，立刻引发了全网热议。</p>

<h3>4. 《仙王的日常生活》外传</h3>
<p>轻松搞笑的风格让这部作品成为了许多读者的日常必追。外传将聚焦于王令的高中生活回忆，带来更多有趣的故事。</p>

<h3>5. 《全职高手》番外篇</h3>
<p>虽然正传已经完结，但叶修的故事依然让人回味无穷。番外篇将讲述荣耀世界的更多秘密。</p>

<p>以上只是2026年国产漫画精彩内容的冰山一角。随着行业的发展，我们有理由相信，国产漫画的未来会更加光明！</p>`,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20and%20comic%20books%20stacked%20on%20desk%2C%20warm%20reading%20atmosphere%2C%20colorful%20manga%20covers%20displayed%2C%20cozy%20indoor%20lighting%2C%20editorial%20photography%20style%2C%20soft%20shadows&width=800&height=400&seq=article-2026-top10&orientation=landscape',
    views: 15600,
  },
  {
    id: 2,
    title: '如何选择适合自己的漫画类型？新手入门指南',
    category: 'slice-of-life',
    author: '资深漫迷老王',
    date: '2026-07-28',
    summary: '面对海量的漫画资源，新手往往不知道从何看起。本文将从多个维度出发，帮助你找到最适合自己的漫画类型。',
    content: `<p>作为一个看了十几年漫画的老漫迷，我经常被朋友问到一个问题："这么多漫画，我该从哪部看起？"今天，我就来分享一下如何选择适合自己的漫画类型。</p>

<h3>第一步：了解自己的喜好</h3>
<p>在选择漫画之前，首先要了解自己喜欢什么类型的影视作品。如果你喜欢动作大片，那么热血和动作类漫画会很适合你；如果你喜欢浪漫爱情片，恋爱类漫画就是你的菜。</p>

<h3>第二步：尝试不同类型</h3>
<p>不要局限于一两种类型。很多经典漫画往往融合了多种元素。比如《诡秘之主》既有悬疑元素，又有奇幻设定；《大王饶命》虽然主打搞笑，但热血场面也不少。</p>

<h3>第三步：关注作者</h3>
<p>如果你喜欢某个作者的某部作品，那么他的其他作品大概率也会符合你的口味。比如喜欢天蚕土豆的《斗破苍穹》，那《元尊》也值得一试。</p>

<h3>第四步：参考社区评价</h3>
<p>51漫画网的用户评价系统可以帮助你快速了解一部漫画的质量。高评分、高阅读量的作品通常不会让人失望。</p>

<p>最后，看漫画最重要的就是开心。不要给自己太大压力，找到自己喜欢的节奏，享受阅读的乐趣就好！</p>`,
    cover: 'https://readdy.ai/api/search-image?query=Person%20reading%20manga%20on%20tablet%20in%20cozy%20cafe%2C%20warm%20ambient%20lighting%2C%20bookshelf%20background%2C%20relaxed%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20natural%20light&width=800&height=400&seq=article-beginner-guide&orientation=landscape',
    views: 23400,
  },
  {
    id: 3,
    title: '国产漫画崛起的背后：从模仿到创新',
    category: 'action',
    author: '动漫产业观察员',
    date: '2026-07-25',
    summary: '近年来，国产漫画经历了从模仿日漫到自主创新的蜕变。这篇文章带你深入了解国产漫画崛起背后的故事。',
    content: `<p>十年前，提到国产漫画，很多人的第一反应是"模仿日本漫画"。但今天，这个印象已经被彻底颠覆。国产漫画正在用自己的方式，书写属于中国漫画的传奇。</p>

<h3>根基：庞大的网络文学IP库</h3>
<p>国产漫画的一个重要优势，就是拥有海量的网络文学IP作为改编基础。《斗破苍穹》《完美世界》《全职高手》等经典作品，都是从热门网络小说改编而来，自带庞大的粉丝群体。</p>

<h3>突破：独特的美术风格</h3>
<p>早期的国产漫画确实在画风上有模仿日漫的痕迹。但近年来，越来越多的国产漫画开始形成自己独特的美术风格。融合了中国传统美学元素的现代漫画，正在获得越来越多读者的认可。</p>

<h3>生态：全产业链布局</h3>
<p>从漫画到动画，从游戏到影视剧，国产漫画已经形成了完整的产业链。一部优秀的漫画作品，往往能够衍生出多种形式的改编，实现IP价值的最大化。</p>

<p>国产漫画的崛起不是偶然，而是整个行业多年积累和努力的结果。未来，我们有理由期待更多优秀的国产漫画走向世界！</p>`,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comic%20artist%20drawing%20manga%20at%20digital%20tablet%2C%20studio%20environment%2C%20creative%20workspace%2C%20warm%20lighting%2C%20professional%20atmosphere%2C%20editorial%20photography%20style&width=800&height=400&seq=article-chinese-manga-rise&orientation=landscape',
    views: 31200,
  },
  {
    id: 4,
    title: '漫画阅读的正确姿势：保护视力小贴士',
    category: 'slice-of-life',
    author: '健康小编阿豪',
    date: '2026-07-20',
    summary: '长时间看漫画对眼睛会有一定影响。本文分享一些实用的护眼技巧，让你在享受漫画的同时也能保护好视力。',
    content: `<p>作为一个资深漫画爱好者，我深知一口气追完几十话漫画的快感。但是，长时间盯着屏幕对我们的眼睛确实不太友好。今天就来分享一些看漫画时的护眼小技巧。</p>

<h3>1. 20-20-20法则</h3>
<p>每看20分钟漫画，就抬头看20英尺（约6米）以外的物体20秒。这个简单的习惯能有效缓解眼部疲劳。</p>

<h3>2. 调整屏幕亮度和色温</h3>
<p>屏幕亮度不宜过高，最好与周围环境光保持一致。建议开启设备的护眼模式或夜间模式，减少蓝光对眼睛的伤害。</p>

<h3>3. 保持正确姿势</h3>
<p>不要躺着看漫画！保持坐姿，设备与眼睛保持30-40厘米的距离。这不仅保护眼睛，也保护颈椎。</p>

<h3>4. 选择大屏设备</h3>
<p>如果条件允许，尽量使用平板电脑或大屏手机阅读漫画。51漫画网的网页版在大屏幕上体验非常出色，高清画质让每一个细节都清晰可见。</p>

<p>爱护眼睛，才能看更多的漫画！希望这些小建议能帮助到大家。</p>`,
    cover: 'https://readdy.ai/api/search-image?query=Person%20reading%20on%20tablet%20with%20warm%20desk%20lamp%2C%20cozy%20evening%20atmosphere%2C%20healthy%20reading%20habits%2C%20soft%20ambient%20lighting%2C%20editorial%20photography%20style&width=800&height=400&seq=article-eye-care&orientation=landscape',
    views: 8700,
  },
  {
    id: 5,
    title: '从《斗破苍穹》看国产热血漫画的叙事技巧',
    category: 'hot-blood',
    author: '文学评论家张教授',
    date: '2026-07-15',
    summary: '作为国产热血漫画的代表作，《斗破苍穹》在叙事方面有着独特的魅力。本文从专业角度分析其成功的叙事策略。',
    content: `<p>《斗破苍穹》作为国产热血漫画的标杆之作，其成功绝非偶然。除了精彩的打斗场面和丰富的世界观设定外，其出色的叙事技巧也是吸引读者的重要原因。</p>

<h3>成长型主角的经典塑造</h3>
<p>萧炎从一个天才少年跌落神坛，再到一步步重回巅峰的成长历程，完美契合了"英雄之旅"的叙事模式。读者能够在主角的成长中看到自己的影子，从而产生强烈的情感共鸣。</p>

<h3>层层递进的冲突设计</h3>
<p>从家族内部的矛盾，到宗门之间的争斗，再到大陆级别的战争，《斗破苍穹》的冲突层级不断升级。这种层层递进的设计让读者始终保持着对剧情的期待感。</p>

<h3>丰富立体的配角塑造</h3>
<p>药老、萧薰儿、美杜莎、云韵...每个重要配角都有自己独立的性格和故事线。他们不是主角的附属品，而是有血有肉的角色，这让整个世界观显得更加真实可信。</p>

<p>《斗破苍穹》的成功为国产漫画提供了宝贵的经验。期待未来能有更多这样精心打磨的优秀作品！</p>`,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20novel%20and%20manga%20display%2C%20literary%20analysis%20scene%2C%20academic%20desk%20with%20books%20and%20notes%2C%20warm%20study%20atmosphere%2C%20editorial%20photography%20style&width=800&height=400&seq=article-doupo-analysis&orientation=landscape',
    views: 18900,
  },
  {
    id: 6,
    title: '悬疑漫画为什么越来越受欢迎？',
    category: 'suspense',
    author: '漫画编辑小陈',
    date: '2026-07-10',
    summary: '近年来，悬疑类漫画的读者群体不断扩大。《诡秘之主》等作品的成功，让越来越多的人爱上了这个类型。',
    content: `<p>如果你关注近年来的漫画市场，一定会发现一个明显的趋势：悬疑类漫画越来越受欢迎了。以《诡秘之主》为代表的一批悬疑漫画，正在收获大量忠实读者。</p>

<h3>智力挑战的快感</h3>
<p>与传统的热血漫画不同，悬疑漫画更注重逻辑推理和智力博弈。读者在阅读过程中，会不自觉地参与到解谜的过程中，这种参与感是其他类型难以提供的。</p>

<h3>世界观的沉浸感</h3>
<p>优秀的悬疑漫画往往能构建一个完整且逻辑自洽的世界观。比如《诡秘之主》的序列体系，既有神秘感，又有严谨的规则设定，让读者能够完全沉浸其中。</p>

<h3>社交属性的加持</h3>
<p>悬疑漫画天然适合讨论和分享。读者们聚在一起分析剧情、预测发展，这种社交体验大大增强了阅读的乐趣。</p>

<p>如果你还没有尝试过悬疑漫画，不妨从《诡秘之主》开始，相信你会打开新世界的大门！</p>`,
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20desk%20with%20magnifying%20glass%20and%20old%20books%2C%20dim%20atmospheric%20lighting%2C%20Victorian%20steampunk%20aesthetic%2C%20editorial%20photography%20style%2C%20soft%20shadows&width=800&height=400&seq=article-suspense-popular&orientation=landscape',
    views: 14500,
  },
];

export const heroSlides = [
  {
    id: 1,
    title: '斗破苍穹 · 最终决战篇',
    subtitle: '萧炎 VS 魂天帝，千年恩怨即将终结',
    comicId: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20fantasy%20scene%2C%20warrior%20surrounded%20by%20flames%20facing%20dark%20enemy%2C%20dramatic%20sky%20with%20fire%20and%20storm%20clouds%2C%20cinematic%20composition%2C%20warm%20orange%20and%20dark%20tones%2C%20anime%20style%20illustration&width=1600&height=700&seq=hero-doupo&orientation=landscape',
  },
  {
    id: 2,
    title: '诡秘之主 · 愚者的盛宴',
    subtitle: '蒸汽朋克世界的非凡冒险，好评如潮',
    comicId: 8,
    image: 'https://readdy.ai/api/search-image?query=Steampunk%20Victorian%20cityscape%20at%20night%2C%20mysterious%20figure%20in%20top%20hat%20and%20coat%2C%20gas%20lamps%20and%20fog%2C%20occult%20symbols%20floating%2C%20cinematic%20atmosphere%2C%20dark%20teal%20and%20gold%20tones%2C%20anime%20style%20illustration&width=1600&height=700&seq=hero-guimi&orientation=landscape',
  },
  {
    id: 3,
    title: '完美世界 · 帝落之战',
    subtitle: '荒天帝的终极对决，谁主沉浮',
    comicId: 2,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20mythological%20battlefield%20with%20divine%20beings%20clashing%2C%20celestial%20palace%20in%20ruins%2C%20epic%20scale%2C%20golden%20divine%20light%20piercing%20through%20clouds%2C%20cinematic%20anime%20style%20illustration&width=1600&height=700&seq=hero-wanmei&orientation=landscape',
  },
];